import {
    Dialog,
    DialogBackdrop,
    DialogPanel,
    TransitionChild,
} from "@headlessui/react";
import {
    ArrowPathIcon,
    Bars3Icon,
    VideoCameraIcon,
    XMarkIcon,
} from "@heroicons/react/24/outline";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useLanguage } from "../../context/Language/LanguageContext";
import { useAuthStatus } from "../hooks/useAuthStatus";
import FeatureGate from "../layout/FeatureGate";
import { kFeatures } from "../utils/access";
import {
    getRotationLabels,
    kSkillPass,
    kSkillServe,
    kSkillSpike
} from "../utils/Constants";
import { makePlaylist, zoneFromString } from "../utils/Utils";
import AICoachPanel from "./AICoachPanel";
import { allFilters } from "./AllFilters";
import AllFiltersPanel from "./AllFiltersPanel";
import HittingChart from "./HittingChart";

function HittingChartReport({
  matches,
  team,
  selectedGame,
  selectedTeam,
  verticalScroll,
}) {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();
  // const { matches, team, selectedGame, selectedTeam } = location.state;
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { currentUser } = useAuthStatus();
  const [drawMode, setDrawMode] = useState(0);
  const [currentTeam, setCurrentTeam] = useState(-1);
  const [allEvents, setAllEvents] = useState(null);
  const [events, setEvents] = useState(null);
  const [allOptions, setAllOptions] = useState(allFilters);
  const [init, setInit] = useState(false);
  const [appName, setAppName] = useState("");
  const [activeTab, setActiveTab] = useState("filters");
  const [aiCoachPlayer, setAiCoachPlayer] = useState(null);
  const [, forceUpdate] = useState(0);

  const doEventsSelected = (evs) => {
    const sortedevs = evs.sort(
      (a, b) => a.TimeStamp.getTime() - b.TimeStamp.getTime()
    );
    const playlist = makePlaylist(sortedevs);
    doPlaylist(playlist);
  };

  const doDoReset = () => {
    for (var n = 0; n < allOptions.length; n++) {
      var option = allOptions[n];
      if (option.title !== "Display") {
        if (option.items) {
          for (var ni = 0; ni < option.items.length; ni++) {
            option.items[ni].selected = true;
          }
        }
      }
    }
    const opts = { allOptions: allOptions, dates: matchdates() };
    localStorage.setItem("VBLiveHittingChartsOptions", JSON.stringify(opts));
  };

  const doReset = () => {
    doDoReset();
    calculateZones();
  };

  const doVideo = () => {
    const selrows = selectedRows();
    var evs = [];
    for (var row = 0; row < 6; row++) {
      if (selrows.includes((row + 1).toString())) {
        for (var z = 0; z < 9; z++) {
          evs = evs.concat(events[row][z]);
        }
      }
    }
    const sortedevs = evs.sort(
      (a, b) => a.TimeStamp.getTime() - b.TimeStamp.getTime()
    );
    const playlist = makePlaylist(sortedevs);
    doPlaylist(playlist);
  };

  const doPlaylist = (playlist) => {
    if (playlist.length === 0) {
      toast.error(t("No events in selected zone."));
    } else {
      const evstr = JSON.stringify(playlist);
      localStorage.setItem("VBLivePlaylistEvents", evstr);
      const pl = {
        events: playlist,
      };
      const fn = null;
      const buffer = JSON.stringify(pl);
      const st = {
        playlistFileData: buffer,
        filename: null,
        playlists: null,
        serverName: currentUser.email,
      };
      navigate("/playlist", { state: st });
    }
  };

  const doUpdate = () => {
    const opts = { allOptions: allOptions, dates: matchdates() };
    localStorage.setItem("VBLiveHittingChartsOptions", JSON.stringify(opts));
    forceUpdate((n) => !n);
    setDrawMode(checkFilter("Display", "Cone") ? 1 : 0);
    var xevents = calculateZones();
  };

  const getAttackComboOfEvent = (code) => {
    for (var match of matches) {
      var acs = match.attackCombos.filter((ac) => {
        return ac.code === code;
      });
      if (acs.length > 0) {
        return acs[0];
      }
    }
    return null;
  };

  const checkFilter = (filtername, objectname) => {
    for (var n = 0; n < allOptions.length; n++) {
      var option = allOptions[n];
      if (option.title === filtername) {
        if (option.items === undefined) {
          return true;
        }
        for (var ni = 0; ni < option.items.length; ni++) {
          if (
            option.items[ni].name === objectname ||
            option.items[ni].number === objectname
          ) {
            return option.items[ni].selected;
          }
        }
      }
    }
    return false;
  };

  const doInit = () => {
    if (matches[0].app === "DataVolley") {
      setAppName("DataVolley");
    } else {
      setAppName("VBStats");
    }

    // const opts = localStorage.getItem("VBLiveHittingChartsOptions");
    // if (opts) {
    //   const options = JSON.parse(opts);
    //   if (options.dates === matchdates()) {
    //     for (var n = 0; n < options.allOptions.length; n++) {
    //       var option = options.allOptions[n];
    //       if (option.items) {
    //         for (var ni = 0; ni < option.items.length; ni++) {
    //           try {
    //             if (
    //               option.items[ni] &&
    //               options.allOptions[n].items &&
    //               options.allOptions[n].items[ni]
    //             ) {
    //               option.items[ni].selected =
    //                 options.allOptions[n].items[ni].selected;
    //             }
    //           } catch (error) {
    //             console.log(error);
    //           }
    //         }
    //       }
    //     }
    //     setDrawMode(checkFilter("Display", "Cone") ? 1 : 0);
    //     return;
    //   }
    // }
    doDoReset();
    var evs = [];
    for (var match of matches) {
      var tm = null;
      if (matches.length === 1) {
        tm = selectedTeam === 0 ? match.teamA : match.teamB;
      } else {
        tm =
          selectedTeam === 0
            ? team === match.teamA.Name
              ? match.teamA
              : match.teamB
            : team === match.teamA.Name
            ? match.teamB
            : match.teamA;
      }
      var xevs =
        !selectedGame || selectedGame === 0
          ? match.events
          : match.sets[selectedGame - 1].events;
      var setter = null;
      for (var ne = 0; ne < xevs.length; ne++) {
        var e = xevs[ne];
        if (
          e.Player !== null &&
          tm.players.filter((obj) => obj.Guid === e.Player.Guid).length > 0
        ) {
          if (e.EventType == kSkillSpike) {
            evs.push(e);
          }
        }
      }
    }
    setAllEvents(evs);
    setSpikerNames(evs);
    if (matches[0].app === "DataVolley") {
      setSetterNames(evs);
      setAttackCombos(evs);
    }
    const opts = localStorage.getItem("VBLiveHittingChartsOptions");
    if (opts) {
      const options = JSON.parse(opts);
      if (options.dates === matchdates()) {
        for (var n = 0; n < options.allOptions.length; n++) {
          var option = allOptions[n];
          if (option.items) {
            for (var ni = 0; ni < option.items.length; ni++) {
              try {
                if (
                  option.items[ni] &&
                  options.allOptions[n].items &&
                  options.allOptions[n].items[ni]
                ) {
                  option.items[ni].selected =
                    options.allOptions[n].items[ni].selected;
                }
              } catch (error) {
                console.log(error);
              }
            }
          }
        }
        setDrawMode(checkFilter("Display", "Cone") ? 1 : 0);
        return;
      }
    }
    setInit(true);
  };

  const calculateZones = () => {
    var xevents = [
      [[], [], [], [], [], [], [], [], []],
      [[], [], [], [], [], [], [], [], []],
      [[], [], [], [], [], [], [], [], []],
      [[], [], [], [], [], [], [], [], []],
      [[], [], [], [], [], [], [], [], []],
      [[], [], [], [], [], [], [], [], []],
    ];

    for (var match of matches) {
      var tm = null;
      if (matches.length === 1) {
        tm = selectedTeam === 0 ? match.teamA : match.teamB;
      } else {
        tm =
          selectedTeam === 0
            ? team === match.teamA.Name
              ? match.teamA
              : match.teamB
            : team === match.teamA.Name
            ? match.teamB
            : match.teamA;
      }
      var xevs =
        selectedGame === 0 ? match.events : match.sets[selectedGame - 1].events;
      var setter = null;
      var evs = [];
      for (var ne = 0; ne < xevs.length; ne++) {
        var e = xevs[ne];
        if (
          e.Player !== null &&
          tm.players.filter((obj) => obj.Guid === e.Player.Guid).length > 0
        ) {
          if (e.EventType == kSkillSpike) {
            evs.push(e);
          }
        }
      }
      /*
      if (currentTeam !== selectedTeam) {
        setAllEvents(evs);
        setSpikerNames(evs);
        if (match.app !== "VBStats") {
          setSetterNames(evs);
          setAttackCombos(evs);
        }
        setCurrentTeam(selectedTeam);
      }
*/
      const egs = ["Errors", "In-play", "In-play", "Kill"];
      const srcs = { F: "Front", B: "Back", C: "Centre" };

      if (match.app === "VBStats") {
        for (var ne = 0; ne < evs.length; ne++) {
          var e = evs[ne];
          if (
            checkFilter("Stages", e.isSideOut ? "Side Out" : "Transition") ===
            false
          ) {
            continue;
          }
          var plname = e.Player.shirtNumber + ". " + e.Player.NickName;
          if (checkFilter("Attackers", plname) === false) {
            continue;
          }
          if (checkFilter("Results", egs[e.EventGrade]) === false) {
            continue;
          }
          var startZone = zoneFromString(e.BallStartString);
          if (
            startZone > 0 &&
            e.Row !== undefined &&
            isNaN(e.Row) === false &&
            e.Row > 0
          ) {
            xevents[e.Row - 1][startZone - 1].push(e);
          }
        }
      } else {
        for (var ne = 0; ne < evs.length; ne++) {
          var e = evs[ne];
          if (
            checkFilter("Stages", e.isSideOut ? "Side Out" : "Transition") ===
            false
          ) {
            continue;
          }
          if (checkFilter("Sets", e.Drill.GameNumber.toString()) === false) {
            continue;
          }
          var plname = e.Player.shirtNumber + ". " + e.Player.NickName;
          if (checkFilter("Attackers", plname) === false) {
            continue;
          }
          if (e.setter !== null && checkFilter("Setters", e.setter) === false) {
            continue;
          }
          if (checkFilter("Results", egs[e.EventGrade]) === false) {
            continue;
          }

          var nacs = match.attackCombos.length;
          var ac =
            e.attackCombo === "~~"
              ? { code: "~~" }
              : getAttackComboOfEvent(e.attackCombo);
          if (ac === null || ac.code === undefined) {
            continue;
          }
          if (checkFilter("Attack Combos", ac.code) === false) {
            continue;
          }
          if (checkFilter("Source", srcs[ac.targetHitter]) === false) {
            continue;
          }
          if (
            (nacs > 0 && ac != null && ac.targetHitter !== "-") ||
            nacs == 0
          ) {
            var row = e.Row - 1;
            var startZone = 0;
            if (nacs > 0) {
              if (ac.startZone !== undefined) {
                startZone = Number.parseInt(ac.startZone);
              } else {
                if (ac.isBackcourt) {
                  if (ac.targetHitter === "B") {
                    startZone = 9;
                  } else if (ac.targetHitter === "F") {
                    startZone = 7;
                  } else {
                    startZone = 8;
                  }
                } else {
                  if (ac.targetHitter === "B") {
                    startZone = 2;
                  } else if (ac.targetHitter === "F") {
                    startZone = 4;
                  } else {
                    startZone = 3;
                  }
                }
              }
            } else {
              startZone = zoneFromString(e.BallStartString);
            }
            if (startZone > 0) {
              xevents[row][startZone - 1].push(e);
            } else {
              // DLog(@"%@ %@", e.attackCombo, e.Player.LastName);
            }
          } else {
            // DLog(@"%@ %@", e.attackCombo, e.Player.LastName);
          }
        }
      }
    }
    setEvents(xevents);
    return xevents;
  };

  const setSpikerNames = (xevents) => {
    if (matches === null) {
      return;
    }
    for (var match of matches) {
      var tm =
        selectedTeam === 0
          ? team === match.teamA.Name
            ? match.teamA
            : match.teamB
          : team === match.teamA.Name
          ? match.teamB
          : match.teamA;
      for (var n = 0; n < allOptions.length; n++) {
        var option = allOptions[n];
        if (option.title === "Attackers") {
          option.items = [];
          for (var ne = 0; ne < xevents.length; ne++) {
            var evx = xevents[ne];
            var pl = evx.Player;
            var plname = pl.shirtNumber + ". " + pl.NickName;
            if (
              option.items.filter((obj) => obj.name == plname).length === 0
            ) {
              option.items.push({
                name: plname,
                selected: true,
                amount: 0,
              });
            }
          }
        }
      }
    }
  };

  const setSetterNames = (xevents) => {
    if (matches === null) {
      return;
    }
    for (var match of matches) {
      for (var n = 0; n < allOptions.length; n++) {
        var option = allOptions[n];
        if (option.title === "Setters") {
          var setters = [];
          for (var ne = 0; ne < xevents.length; ne++) {
            var evx = xevents[ne];
            var sn = evx.setter;
            if (setters.filter((obj) => obj == sn).length === 0) {
              setters.push(sn);
            }
          }
          option.items = [];
          for (var nn = 0; nn < setters.length; nn++) {
            var tm =
              selectedTeam === 0
                ? team === match.teamA.Name
                  ? match.teamA
                  : match.teamB
                : team === match.teamA.Name
                ? match.teamA
                : match.teamB;
            var pls = tm.players;
            for (var np = 0; np < pls.length; np++) {
              var pl = pls[np];
              if (pl.shirtNumber === setters[nn]) {
                var plname = pl.shirtNumber + ". " + pl.NickName;
                option.items.push({
                  name: plname,
                  number: pl.shirtNumber,
                  selected: true,
                  amount: 0,
                });
                break;
              }
            }
          }
        }
      }
    }
  };

  const setAttackCombos = (xevents) => {
    if (matches === null) {
      return;
    }
    for (var n = 0; n < allOptions.length; n++) {
      var option = allOptions[n];
      if (option.title === "Attack Combos") {
        option.items = [];
        for (var ne = 0; ne < xevents.length; ne++) {
          var evx = xevents[ne];
          var ac = evx.attackCombo;
          if (option.items.filter((obj) => obj.name == ac).length === 0) {
            option.items.push({ name: ac, selected: true, amount: 0 });
          }
        }
      }
    }
  };

  const selectedRows = () => {
    var rows = [];
    for (var n = 0; n < allOptions.length; n++) {
      var option = allOptions[n];
      if (option.title === "Rotations") {
        for (var ni = 0; ni < option.items.length; ni++) {
          if (option.items[ni].selected) {
            rows.push(option.items[ni].name);
          }
        }
      }
    }
    return rows;
  };

  const teamForMatch = (match) => {
    if (matches.length === 1) {
      return selectedTeam === 0 ? match.teamA : match.teamB;
    }
    return selectedTeam === 0
      ? team === match.teamA.Name
        ? match.teamA
        : match.teamB
      : team === match.teamA.Name
      ? match.teamB
      : match.teamA;
  };

  const startZoneForEvent = (match, e) => {
    if (match.app === "VBStats") {
      return zoneFromString(e.BallStartString);
    }
    var nacs = match.attackCombos.length;
    var ac =
      e.attackCombo === "~~"
        ? { code: "~~" }
        : getAttackComboOfEvent(e.attackCombo);
    if (ac === null || ac.code === undefined) {
      return 0;
    }
    if ((nacs > 0 && ac != null && ac.targetHitter !== "-") || nacs == 0) {
      var startZone = 0;
      if (nacs > 0) {
        if (ac.startZone !== undefined) {
          startZone = Number.parseInt(ac.startZone);
        } else {
          if (ac.isBackcourt) {
            if (ac.targetHitter === "B") {
              startZone = 9;
            } else if (ac.targetHitter === "F") {
              startZone = 7;
            } else {
              startZone = 8;
            }
          } else {
            if (ac.targetHitter === "B") {
              startZone = 2;
            } else if (ac.targetHitter === "F") {
              startZone = 4;
            } else {
              startZone = 3;
            }
          }
        }
      } else {
        startZone = zoneFromString(e.BallStartString);
      }
      return startZone;
    }
    return 0;
  };

  const spikeResult = (e) => {
    const isVBStats =
      e.Drill && e.Drill.match
        ? e.Drill.match.app === "VBStats"
        : appName === "VBStats";
    if (isVBStats) {
      if (e.EventGrade === 3) return "kill";
      if (e.EventGrade === 0) return "error";
      return "inplay";
    }
    if (e.DVGrade === "#") return "kill";
    if (e.DVGrade === "=" || e.DVGrade === "/") return "error";
    return "inplay";
  };

  const playerKey = (pl) => {
    if (!pl) {
      return "";
    }
    return pl.shirtNumber + ". " + pl.NickName;
  };

  const playersWithSpikes = () => {
    var pls = [];
    if (!allEvents) {
      return pls;
    }
    for (var e of allEvents) {
      var pl = e.Player;
      if (!pl || e.EventType != kSkillSpike) {
        continue;
      }
      var key = playerKey(pl);
      var existing = pls.filter((obj) => obj.guid === key);
      if (existing.length === 0) {
        pls.push({
          guid: key,
          name: key,
          count: 1,
        });
      } else {
        existing[0].count += 1;
      }
    }
    return pls
      .filter((obj) => obj.count > 0)
      .sort((a, b) => b.count - a.count);
  };

  const buildPlayerZones = (playerGuid) => {
    var xevents = [
      [[], [], [], [], [], [], [], [], []],
      [[], [], [], [], [], [], [], [], []],
      [[], [], [], [], [], [], [], [], []],
      [[], [], [], [], [], [], [], [], []],
      [[], [], [], [], [], [], [], [], []],
      [[], [], [], [], [], [], [], [], []],
    ];
    if (!playerGuid) {
      return xevents;
    }
    for (var match of matches) {
      var tm = teamForMatch(match);
      var xevs =
        !selectedGame || selectedGame === 0
          ? match.events
          : match.sets[selectedGame - 1].events;
      for (var ne = 0; ne < xevs.length; ne++) {
        var e = xevs[ne];
        if (
          e.Player !== null &&
          playerKey(e.Player) === playerGuid &&
          tm.players.filter((obj) => obj.Guid === e.Player.Guid).length > 0 &&
          e.EventType == kSkillSpike
        ) {
          var row = e.Row !== undefined ? e.Row - 1 : -1;
          var startZone = startZoneForEvent(match, e);
          if (startZone > 0 && row >= 0 && row < 6) {
            xevents[row][startZone - 1].push(e);
          }
        }
      }
    }
    return xevents;
  };

  const buildPlayerAnalysisData = (playerGuid) => {
    if (!playerGuid || !allEvents) {
      return null;
    }
    var name = "";
    var firstName = "";
    var lastName = "";
    var nickName = "";
    var shirtNumber = "";
    var role = "";
    var totalSpikes = 0;
    var kills = 0;
    var errors = 0;
    var inPlay = 0;
    var startZoneMap = {};
    var landingZoneMap = {};

    // Situational tendency accumulators.
    const newBucket = () => ({ total: 0, kills: 0, errors: 0 });
    const addToBucket = (map, key, result) => {
      if (key === null || key === undefined || key === "") {
        return;
      }
      if (!map[key]) {
        map[key] = newBucket();
      }
      map[key].total += 1;
      if (result === "kill") map[key].kills += 1;
      else if (result === "error") map[key].errors += 1;
    };
    var phaseMap = {}; // Side Out (first-ball) vs Transition
    var leverageMap = {}; // High-leverage vs Normal
    var scoreStateMap = {}; // Behind / Tied / Ahead
    var blockersMap = {}; // 0 / 1 / 2 / 3 blockers
    var setterMap = {}; // by setter
    var passGradeMap = {}; // by reception pass grade
    var rotationMap = {}; // efficiency by rotation (Row 1-6)
    // Map the rotation-sequence row (1-6) to the user's chosen rotation label
    // (e.g. R1..R6 or S1,S6,S5,...) so the AI report names rotations correctly.
    var rotationLabels = getRotationLabels();
    var rotationLabelForRow = (row) => rotationLabels[row - 1] || "R" + row;
    var frontBackMap = {}; // front row vs back row attack
    var setTypeMap = {}; // set type / tempo (attack combo)
    var systemMap = {}; // in-system vs out-of-system
    var setCount = 0; // number of distinct sets the player appears in
    var setKeys = {};

    const setTypeFromEvent = (e, match) => {
      if (!match || match.app === "VBStats") {
        return null;
      }
      var ac =
        e.attackCombo === "~~"
          ? null
          : getAttackComboOfEvent(e.attackCombo);
      if (!ac || ac.code === undefined) {
        return null;
      }
      var tempoLabels = {
        Q: "Quick (1st tempo)",
        H: "High ball (3rd tempo)",
        M: "Medium (2nd tempo)",
        T: "Tense / shoot",
        U: "Super / fast",
        N: "Fast",
        O: "Other",
      };
      var tempo =
        ac.ballType && tempoLabels[ac.ballType]
          ? tempoLabels[ac.ballType]
          : ac.ballType || "Unknown tempo";
      var label = ac.name ? `${ac.name} (${tempo})` : tempo;
      return label;
    };

    const frontBackFromEvent = (e, match) => {
      // Use the attack origin: zones 2,3,4 are front-court; 1,5,6,7,8,9 are
      // back-court attacks. For DataVolley also respect the combo backcourt
      // flag when available.
      if (match && match.app !== "VBStats") {
        var ac =
          e.attackCombo === "~~"
            ? null
            : getAttackComboOfEvent(e.attackCombo);
        if (ac && ac.isBackcourt !== undefined && !isNaN(ac.isBackcourt)) {
          return ac.isBackcourt ? "Back row" : "Front row";
        }
      }
      var sz = startZoneForEvent(match, e);
      if (sz <= 0) {
        return null;
      }
      return sz === 2 || sz === 3 || sz === 4 ? "Front row" : "Back row";
    };

    const systemFromEvent = (e) => {
      // In-system if reception/dig was good (# or +), out-of-system otherwise.
      if (e.UserDefined01 && e.UserDefined01.length >= 6) {
        var g = e.UserDefined01.substring(5, 6);
        if (g === "#" || g === "+") return "In-system";
        if (g === "!" || g === "-" || g === "/" || g === "=")
          return "Out-of-system";
      }
      return null;
    };


    const passGradeFromEvent = (e) => {
      // For DataVolley the previous reception code is stored in UserDefined01;
      // its 6th character (index 5) is the pass quality symbol.
      if (e.UserDefined01 && e.UserDefined01.length >= 6) {
        const g = e.UserDefined01.substring(5, 6);
        const labels = {
          "#": "Perfect (#)",
          "+": "Good (+)",
          "!": "OK (!)",
          "-": "Poor (-)",
          "/": "Poor (/)",
          "=": "Error (=)",
        };
        return labels[g] || null;
      }
      return null;
    };

    const blockersFromEvent = (e) => {
      // DataVolley spike code: blockers count is ExtraCode1 (char index 12).
      var raw = e.ExtraCode1;
      if (raw === undefined || raw === null || raw === "") {
        return null;
      }
      var n = parseInt(raw, 10);
      if (isNaN(n) || n < 0 || n > 3) {
        return null;
      }
      if (n === 0) return "No block (0)";
      if (n === 1) return "1 blocker";
      if (n === 2) return "2 blockers";
      return "3 blockers";
    };

    const scoreStateFromEvent = (e) => {
      if (
        e.TeamScore === undefined ||
        e.OppositionScore === undefined ||
        e.TeamScore === null ||
        e.OppositionScore === null
      ) {
        return null;
      }
      // Scores are stored from the home team's perspective. Express the state
      // from the attacking player's team point of view.
      var diff =
        selectedTeam === 0
          ? e.TeamScore - e.OppositionScore
          : e.OppositionScore - e.TeamScore;
      if (diff <= -3) return "Behind by 3+";
      if (diff < 0) return "Behind 1-2";
      if (diff === 0) return "Tied";
      if (diff <= 2) return "Ahead 1-2";
      return "Ahead by 3+";
    };

    const isHighLeverage = (e) => {
      if (
        e.TeamScore === undefined ||
        e.OppositionScore === undefined ||
        e.TeamScore === null ||
        e.OppositionScore === null
      ) {
        return false;
      }
      var hi = Math.max(e.TeamScore, e.OppositionScore);
      var close = Math.abs(e.TeamScore - e.OppositionScore) <= 2;
      // Late, close situations within a set or extended deuce.
      return close && hi >= 20;
    };

    for (var e of allEvents) {
      if (!e.Player || playerKey(e.Player) !== playerGuid) {
        continue;
      }
      if (!name) {
        name = playerKey(e.Player);
        firstName = e.Player.FirstName ?? e.Player.firstName ?? "";
        lastName = e.Player.LastName ?? e.Player.lastName ?? "";
        nickName = e.Player.NickName ?? e.Player.nickName ?? "";
        shirtNumber = e.Player.shirtNumber ?? e.Player.ShirtNumber ?? "";
        // Most imports only reliably flag the Libero here (DataVolley's own
        // roster field rarely distinguishes MB/OPP/OH) — real role detection
        // for everyone else falls back to serve-receive volume below.
        role = e.Player.Role ?? e.Player.role1 ?? "";
      }
      totalSpikes += 1;
      var result = spikeResult(e);
      if (result === "kill") kills += 1;
      else if (result === "error") errors += 1;
      else inPlay += 1;

      var match = e.Drill && e.Drill.match ? e.Drill.match : matches[0];
      var sz = startZoneForEvent(match, e);
      if (sz > 0) {
        if (!startZoneMap[sz]) {
          startZoneMap[sz] = { zone: sz, total: 0, kills: 0, errors: 0 };
        }
        startZoneMap[sz].total += 1;
        if (result === "kill") startZoneMap[sz].kills += 1;
        else if (result === "error") startZoneMap[sz].errors += 1;
      }

      if (e.BallEndString) {
        var lz = zoneFromString(e.BallEndString);
        if (lz > 0) {
          if (!landingZoneMap[lz]) {
            landingZoneMap[lz] = { zone: lz, total: 0, kills: 0 };
          }
          landingZoneMap[lz].total += 1;
          if (result === "kill") landingZoneMap[lz].kills += 1;
        }
      }

      // Situational tendencies.
      addToBucket(
        phaseMap,
        e.isSideOut ? "Side out (first ball)" : "Transition",
        result
      );
      if (isHighLeverage(e)) {
        addToBucket(leverageMap, "High-leverage (late & close)", result);
      }
      addToBucket(scoreStateMap, scoreStateFromEvent(e), result);
      addToBucket(blockersMap, blockersFromEvent(e), result);
      if (e.setter !== null && e.setter !== undefined && e.setter !== "") {
        addToBucket(setterMap, "Setter " + e.setter, result);
      }
      addToBucket(passGradeMap, passGradeFromEvent(e), result);

      // Player-level tendencies.
      if (e.Row !== undefined && !isNaN(e.Row) && e.Row > 0) {
        addToBucket(rotationMap, "Rotation " + rotationLabelForRow(e.Row), result);
      }
      addToBucket(frontBackMap, frontBackFromEvent(e, match), result);
      addToBucket(setTypeMap, setTypeFromEvent(e, match), result);
      addToBucket(systemMap, systemFromEvent(e), result);

      var gameNo =
        e.Drill && e.Drill.GameNumber !== undefined
          ? e.Drill.GameNumber
          : null;
      var matchId = match && match.guid ? match.guid : "m";
      var setKey = matchId + "_" + gameNo;
      if (!setKeys[setKey]) {
        setKeys[setKey] = true;
        setCount += 1;
      }
    }

    // ---- Serve-receive (passing) analysis ----
    // The spike-only `allEvents` does not contain reception events, so iterate
    // the raw match/set events to (a) measure the player's passing volume and
    // quality and (b) compare attack efficiency on rallies where the player
    // received the serve versus rallies where they did not pass.
    const passQualityOfReception = (e) => {
      const isVBStats =
        e.Drill && e.Drill.match
          ? e.Drill.match.app === "VBStats"
          : appName === "VBStats";
      if (isVBStats) {
        const vbLabels = {
          3: { label: "Perfect (3)", positive: true, perfect: true, error: false },
          2: { label: "Good (2)", positive: true, perfect: false, error: false },
          1: { label: "Poor (1)", positive: false, perfect: false, error: false },
          0: { label: "Error (0)", positive: false, perfect: false, error: true },
        };
        return vbLabels[e.EventGrade] || null;
      }
      const dvLabels = {
        "#": { label: "Perfect (#)", positive: true, perfect: true, error: false },
        "+": { label: "Good (+)", positive: true, perfect: false, error: false },
        "!": { label: "OK (!)", positive: false, perfect: false, error: false },
        "-": { label: "Poor (-)", positive: false, perfect: false, error: false },
        "/": { label: "Poor (/)", positive: false, perfect: false, error: false },
        "=": { label: "Error (=)", positive: false, perfect: false, error: true },
      };
      return dvLabels[e.DVGrade] || null;
    };

    var passTotal = 0;
    var passPositive = 0;
    var passPerfect = 0;
    var passError = 0;
    var passGradeReceiveMap = {}; // reception grade distribution
    var passLocationMap = {}; // reception location (court zone)
    var attackPassMap = {}; // attack efficiency: after own reception vs not

    for (var pm of matches) {
      var ptm = teamForMatch(pm);
      var pevs =
        !selectedGame || selectedGame === 0
          ? pm.events
          : pm.sets[selectedGame - 1].events;
      var lastPasserGuid = null;
      for (var pe of pevs) {
        // A serve marks the start of a new rally; clear the rally's passer.
        if (pe.EventType === kSkillServe) {
          lastPasserGuid = null;
          continue;
        }
        if (!pe.Player) {
          continue;
        }
        var peKey = playerKey(pe.Player);
        var onTeam =
          ptm.players.filter((obj) => obj.Guid === pe.Player.Guid).length > 0;

        if (pe.EventType === kSkillPass && onTeam) {
          lastPasserGuid = peKey;
          if (peKey === playerGuid) {
            passTotal += 1;
            var q = passQualityOfReception(pe);
            if (q) {
              addToBucket(
                passGradeReceiveMap,
                q.label,
                q.error ? "error" : q.perfect ? "kill" : "inplay"
              );
              if (q.positive) passPositive += 1;
              if (q.perfect) passPerfect += 1;
              if (q.error) passError += 1;
            }
            var pz = pe.BallStartString
              ? zoneFromString(pe.BallStartString)
              : 0;
            if (pz > 0) {
              if (!passLocationMap[pz]) {
                passLocationMap[pz] = { zone: pz, total: 0 };
              }
              passLocationMap[pz].total += 1;
            }
          }
          continue;
        }

        if (pe.EventType === kSkillSpike && peKey === playerGuid && onTeam) {
          var passedThisRally = lastPasserGuid === playerGuid;
          addToBucket(
            attackPassMap,
            passedThisRally
              ? "After own serve-receive"
              : "When not passing",
            spikeResult(pe)
          );
        }
      }
    }

    if (totalSpikes === 0) {
      return null;
    }


    var startZones = Object.values(startZoneMap)
      .map((z) => ({
        ...z,
        killPct: z.total > 0 ? (z.kills * 100) / z.total : 0,
      }))
      .sort((a, b) => b.total - a.total);
    var landingZones = Object.values(landingZoneMap).sort(
      (a, b) => b.total - a.total
    );

    const mapToTendencies = (map) =>
      Object.keys(map)
        .map((key) => {
          var b = map[key];
          return {
            label: key,
            total: b.total,
            kills: b.kills,
            errors: b.errors,
            killPct: b.total > 0 ? (b.kills * 100) / b.total : 0,
            efficiency:
              b.total > 0 ? ((b.kills - b.errors) * 100) / b.total : 0,
          };
        })
        .sort((a, b) => b.total - a.total);

    return {
      name: name,
      firstName: firstName,
      lastName: lastName,
      nickName: nickName,
      shirtNumber: shirtNumber,
      role: role,
      totalSpikes: totalSpikes,
      kills: kills,
      errors: errors,
      inPlay: inPlay,
      killPct: totalSpikes > 0 ? (kills * 100) / totalSpikes : 0,
      errorRate: totalSpikes > 0 ? (errors * 100) / totalSpikes : 0,
      efficiency: totalSpikes > 0 ? ((kills - errors) * 100) / totalSpikes : 0,
      attacksPerSet: setCount > 0 ? totalSpikes / setCount : totalSpikes,
      setCount: setCount,
      startZones: startZones,
      landingZones: landingZones,
      phaseTendencies: mapToTendencies(phaseMap),
      highLeverageTendencies: mapToTendencies(leverageMap),
      scoreStateTendencies: mapToTendencies(scoreStateMap),
      blockerTendencies: mapToTendencies(blockersMap),
      setterTendencies: mapToTendencies(setterMap),
      passGradeTendencies: mapToTendencies(passGradeMap),
      rotationTendencies: mapToTendencies(rotationMap),
      frontBackTendencies: mapToTendencies(frontBackMap),
      setTypeTendencies: mapToTendencies(setTypeMap),
      systemTendencies: mapToTendencies(systemMap),
      passing: {
        total: passTotal,
        positive: passPositive,
        perfect: passPerfect,
        errors: passError,
        positivePct: passTotal > 0 ? (passPositive * 100) / passTotal : 0,
        perfectPct: passTotal > 0 ? (passPerfect * 100) / passTotal : 0,
        errorPct: passTotal > 0 ? (passError * 100) / passTotal : 0,
        passesPerSet: setCount > 0 ? passTotal / setCount : passTotal,
        // Most real rosters don't label MB/Opposite explicitly, so a small
        // reception sample (a couple of stray/short serves a whole match) is
        // the practical signal that this player isn't a real serve-receive
        // target, regardless of how good/bad those few passes graded.
        isLikelySecondaryReceiver: passTotal > 0 && (passTotal < 6 || (setCount > 0 && passTotal / setCount < 1)),
        gradeTendencies: mapToTendencies(passGradeReceiveMap),
        locations: Object.values(passLocationMap).sort(
          (a, b) => b.total - a.total
        ),
      },
      attackWhenPassingTendencies: mapToTendencies(attackPassMap),
    };
  };

  const matchdates = () => {
    var dates = "";
    for (var xm of matches) {
      dates += xm.sessionDateString
        ? xm.sessionDateString
        : xm.TrainingDate.toLocaleString();
    }
    return dates;
  };

  useEffect(() => {
    doInit();
    var xevents = calculateZones();
  }, [selectedGame, selectedTeam]);

  useEffect(() => {
    // console.log("vs=", verticalScroll);
    // forceUpdate((n) => !n);
  }, [events, verticalScroll]);

  if (events === null) {
    return <></>;
  }

  const doLeftSide = () => {
    return (
      <>
        <div className="flex flex-col h-full">
          <div className="flex justify-between bg-base-300 p-1 h-10">
            <div className="tooltip tooltip-right" data-tip={t("Reset all filters")}>
              <ArrowPathIcon
                className="btn-toolbar"
                onClick={() => doReset()}
              />
            </div>
            <div
              className="tooltip tooltip-left"
              data-tip={t("Show video clips of filtered attacks")}
              style={{ whiteSpace: "pre-line" }}
            >
              <VideoCameraIcon
                className="btn-toolbar"
                onClick={() => doVideo()}
              />
            </div>
          </div>
          <div role="tablist" className="tabs tabs-boxed bg-base-300 rounded-none">
            <button
              type="button"
              role="tab"
              className={
                "tab" + (activeTab === "filters" ? " tab-active" : "")
              }
              onClick={() => setActiveTab("filters")}
            >
              {t("Filters")}
            </button>
            <button
              type="button"
              role="tab"
              className={
                "tab" + (activeTab === "aicoach" ? " tab-active" : "")
              }
              onClick={() => setActiveTab("aicoach")}
            >
              {t("AI Report")}
            </button>
          </div>
          <div className="flex-1 min-h-0 overflow-auto bg-base-200">
            {activeTab === "filters" ? (
              <AllFiltersPanel
                allOptions={allOptions}
                match={matches[0]}
                events={events}
                selectedTeam={selectedTeam}
                handleFilterOptionChanged={() => doUpdate()}
                appName={appName}
              />
            ) : (
              <FeatureGate
                feature={kFeatures.AI_REPORTS}
                featureName="AI Report"
              >
                <AICoachPanel
                  players={playersWithSpikes()}
                  selectedPlayerGuid={aiCoachPlayer}
                  onPlayerSelected={(guid) => setAiCoachPlayer(guid)}
                  analysisData={buildPlayerAnalysisData(aiCoachPlayer)}
                  isPlayerTeamA={selectedTeam === 0}
                  matches={matches}
                  selectedGame={selectedGame}
                  selectedTeam={selectedTeam}
                />
              </FeatureGate>
            )}
          </div>
        </div>
      </>
    );
  };

  const doRightSide = () => {
    const showAI = activeTab === "aicoach" && aiCoachPlayer;
    const chartEvents = showAI ? buildPlayerZones(aiCoachPlayer) : events;
    const chartRows = showAI
      ? ["1", "2", "3", "4", "5", "6"]
      : selectedRows();
    return (
      <>
        <div className="flex-col">
          <p className="text-sm font-semibold text-base-content/50">
            {showAI
              ? t("Spikes for the selected player")
              : t("Click on the zones to view video of attacks")}
          </p>
          <div className="w-100 h-full cursor-pointer">
            <HittingChart
              matches={matches}
              events={chartEvents}
              rows={chartRows}
              drawMode={drawMode}
              onEventsSelected={(evs) => doEventsSelected(evs)}
            />
          </div>
        </div>
      </>
    );
  };

  const onBackClick = () => {
    navigate(-1);
  };

  const getTeamName = () => {
    if (selectedTeam === 0) {
      return team.toUpperCase();
    } else {
      if (matches.length === 1) {
        return matches[0].teamB.Name.toUpperCase();
      } else {
        return "OPPONENTS (" + matches.length + ")";
      }
    }
  };

  const verticalInset = (h) => {
    const yy = h - verticalScroll;
    // console.log("yy = ", yy);
    return yy;
  };

  return (
    <>
      <div className="">
        <div>
          <Dialog
            open={sidebarOpen}
            onClose={setSidebarOpen}
            className="relative z-50 lg:hidden"
          >
            <DialogBackdrop
              transition
              className="fixed inset-0 bg-gray-900/80 transition-opacity duration-300 ease-linear data-[closed]:opacity-0"
            />

            <div
              className="fixed inset-0 inset-y-[180px] flex"
              style={{
                top: `${verticalInset(180)}px`,
                bottom: 0,
              }}
            >
              <DialogPanel
                transition
                className="relative mr-16 flex w-full max-w-[320px] flex-1 transform transition duration-300 ease-in-out data-[closed]:-translate-x-full"
              >
                <TransitionChild>
                  <div className="absolute left-full top-0 flex w-16 justify-center pt-5 duration-300 ease-in-out data-[closed]:opacity-0">
                    <button
                      type="button"
                      onClick={() => setSidebarOpen(false)}
                      className="-m-2.5 p-2.5"
                    >
                      <span className="sr-only">Close sidebar</span>
                      <XMarkIcon
                        aria-hidden="true"
                        className="size-6 text-white"
                      />
                    </button>
                  </div>
                </TransitionChild>
                {/* Sidebar component, swap this element with another sidebar if you like */}
                <div className="flex grow flex-col min-h-0 bg-base-100">
                  {doLeftSide()}
                </div>
              </DialogPanel>
            </div>
          </Dialog>

          {/* Static sidebar for desktop */}
          <div
            className="hidden lg:fixed lg:z-50 lg:flex lg:w-[320px] lg:flex-col"
            style={{
              top: `${verticalInset(210)}px`,
              bottom: 0,
            }}
          >
            {/* Sidebar component, swap this element with another sidebar if you like */}
            <div className="flex grow flex-col min-h-0 bg-base-100">{doLeftSide()}</div>
          </div>

          <div className="lg:px-4 lg:ml-72">
            <div className="sticky top-0 z-40 lg:mx-auto lg:max-w-7xl lg:px-0">
              <div className="flex h-10 items-center gap-x-4 border-b border-gray-200 bg-base-300 px-2 shadow-sm sm:gap-x-6 sm:px-0 lg:px-2 lg:shadow-none">
                <button
                  type="button"
                  onClick={() => setSidebarOpen(true)}
                  className="-m-2.5 p-2.5 text-base-content/50 lg:hidden"
                >
                  <span className="sr-only">Open sidebar</span>
                  <Bars3Icon
                    aria-hidden="true"
                    className="size-6 cursor-pointer text-base-content/50 hover:text-base-content/80"
                  />
                </button>

                <div className="flex flex-1 gap-x-4 self-stretch lg:gap-x-6 lg:ml-8">
                  <form
                    action="#"
                    method="GET"
                    className="grid flex-1 grid-cols-1"
                  >
                    {/* <h1 className="text-sm text-center py-2 font-semibold text-gray-900"> */}
                    <div className="flex justify-between">
                      <h1 className="text-lg mt-1 font-semibold text-base-content/70">
                        {getTeamName()}
                      </h1>
                      {/* {doItemDetails()} */}

                      {/* <div className="flex ml-4">
                        <a
                          data-tooltip-id="tt-prev"
                          data-tooltip-content="Previous item"
                        >
                          <button type="button" className="mt-3.5">
                            <span className="sr-only">Navigate Back</span>
                            <ChevronLeftIcon
                              className="size-6 cursor-pointer text-base-content/50 hover:text-base-content/80"
                              onClick={() => moveToItem(-1)}
                            />
                          </button>
                        </a>
                        <Tooltip
                          id="tt-prev"
                          place={"bottom-end"}
                          style={{
                            backgroundColor: "oklch(var(--b3))",
                            color: "oklch(var(--bc))",
                          }}
                        />

                        <a
                          data-tooltip-id="tt-prev"
                          data-tooltip-content="Next item"
                        >
                          <button type="button" className="mt-3.5">
                            <span className="sr-only">Navigate Back</span>
                            <ChevronRightIcon
                              className="size-6 cursor-pointer text-base-content/50 hover:text-base-content/80"
                              onClick={() => moveToItem(1)}
                            />
                          </button>
                        </a>
                        <Tooltip
                          id="tt-prev"
                          place={"bottom-end"}
                          style={{
                            backgroundColor: "oklch(var(--b3))",
                            color: "oklch(var(--bc))",
                          }}
                        />
                      </div> */}
                    </div>
                  </form>
                  <div className="flex items-center gap-x-4 lg:gap-x-6">
                    {/* <button type="button" className="">
                      <span className="sr-only">Navigate Back</span>
                      <XMarkIcon
                        aria-hidden="true"
                        className="size-6 cursor-pointer text-base-content/50 hover:text-base-content/80"
                        onClick={() => onBackClick()}
                      />
                    </button> */}
                  </div>
                </div>
              </div>
            </div>

            <main className="py-2">
              <div className="mx-auto max-w-7xl px-1 sm:pl-0 sm:pr-2 lg:pr-2 lg:pl-8">
                {doRightSide()}
              </div>
            </main>
          </div>
        </div>
      </div>
    </>
  );
}

export default HittingChartReport;
